"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SecretsManager = void 0;
const AWS = require("aws-sdk");
const setup_1 = require("./setup");
const rolled_services_1 = require("./local/rolled.services");
const _ = require("lodash");
const configuration_1 = require("./configuration");
class SecretsManager {
    constructor(environment) {
        this.environment = environment;
        this.logger = setup_1.LoggingService.getLogger("@vacasa/secrets-manager");
    }
    async build() {
        if (_.isNil(this.environment)) {
            const rolledServices = new rolled_services_1.RolledServices();
            this.ssm = await rolledServices.getSecretsManager();
        }
        else {
            AWS.config.update({
                region: configuration_1.Configuration.region(),
            });
            this.ssm = new AWS.SecretsManager({
                apiVersion: configuration_1.Configuration.apiVersion(),
            });
        }
    }
    async getSecret(secretName) {
        try {
            await this.build();
            const data = await this.ssm.getSecretValue({ SecretId: secretName }).promise();
            if ("SecretString" in data) {
                return data.SecretString;
            }
            else {
                let buff = new Buffer(data.SecretBinary, "base64");
                return buff.toString("ascii");
            }
        }
        catch (err) {
            this.logger.error(`getSecret error: ${err.code} - ${err.message}`);
            if (err.code === "DecryptionFailureException")
                // Secrets Manager can't decrypt the protected secret text using the provided KMS key.
                // Deal with the exception here, and/or rethrow at your discretion.
                throw err;
            else if (err.code === "InternalServiceErrorException")
                // An error occurred on the server side.
                // Deal with the exception here, and/or rethrow at your discretion.
                throw err;
            else if (err.code === "InvalidParameterException")
                // You provided an invalid value for a parameter.
                // Deal with the exception here, and/or rethrow at your discretion.
                throw err;
            else if (err.code === "InvalidRequestException")
                // You provided a parameter value that is not valid for the current state of the resource.
                // Deal with the exception here, and/or rethrow at your discretion.
                throw err;
            else if (err.code === "ResourceNotFoundException")
                // We can't find the resource that you asked for.
                // Deal with the exception here, and/or rethrow at your discretion.
                throw err;
            return null;
        }
    }
}
exports.SecretsManager = SecretsManager;
//# sourceMappingURL=secrets.manager.js.map